import React from 'react'
import { graphql } from 'gatsby'
import Img from 'gatsby-image'
import Helmet from 'react-helmet'
import favicon from '../images/favicon.ico'
import Button from '../components/Button'
import ClientList from '../components/ClientList'
import Container from '../Layout/Container'
import DoMoreWithEmail from '../sections/DoMoreWithEmail'
import GeneralSection from '../sections/GeneralSection'
import HistoryTimeline from '../sections/HistoryTimeline'
import Layout from '../Layout/Layout'
import MasonryCards from '../components/MasonryCards'
import MeetTheTeam from '../sections/MeetTheTeam'
import PageHeader from '../sections/PageHeaderSection'
import SEO from '../components/seo'
import SingleQuote from '../components/SingleQuote'
import TextHeader from '../components/TextHeader'

const CompanyPage = ({ data }) => {
  const companyData = data.contentfulCompanyPage
  const theBeginingButton = companyData.theBegining.filter(
    item => item.__typename === 'ContentfulButton'
  )[0]
  return (
    <>
      <Layout>
        <SEO
          title="Company"
          url="https://www.mailgun.com/company/"
          type="website"
        />
        <Helmet defer={false}>
          <title>Flexible Pricing & Email Delivery Plans - Email API Service</title>
          <meta
            name="description"
            content="Meet the Mailgun Leaders - Email API Service for Developers"
          />
          <meta name="robots" content="index,follow" />
          <link rel="canonical" href="https://www.mailgun.com/company/" />
          <link rel="icon" href={favicon} />
        </Helmet>
        <Container fullWidth>
          <PageHeader>
            <main>
              {' '}
              {/*The main section is on the dark blue background */}
              <TextHeader
                mdTitle={companyData.pageHeader.title.title}
                subtitle={companyData.pageHeader.subtitleTop}
                theme={{
                  size: 'big',
                  align: 'center',
                }}
              />
            </main>

            <article className="company">
              {' '}
              {/*The footer is everything below with grey background */}
              <Img fluid={companyData.frontImage.fluid} />
              {/*Image shifted to the top */}
              <TextHeader
                mdTitle={
                  companyData.theBegining.filter(
                    item => item.__typename === 'ContentfulTextHeader'
                  )[0].title.title
                }
                subtitle={
                  companyData.theBegining.filter(
                    item => item.__typename === 'ContentfulTextHeader'
                  )[0].subtitleTop
                }
                mdText={
                  companyData.theBegining.filter(
                    item => item.__typename === 'ContentfulTextHeader'
                  )[0].text.text
                }
                theme={{
                  size: 'big',
                  align: 'center',
                }}
              />
              <Button
                ghost="true"
                to={theBeginingButton.buttonLink}
                external={theBeginingButton.external}
                isAbsolutePath={theBeginingButton.isAbsolutePath}
              >
                {theBeginingButton.buttonText}
              </Button>
            </article>
          </PageHeader>
        </Container>
        <Container fullWidth>
          <DoMoreWithEmail ghost data={companyData.ourMission} />
        </Container>
        <Container fullWidth>
          <GeneralSection>
            <div>
              <TextHeader
                subtitle="you're in good company"
                theme={{
                  align: 'center',
                  color: 'light',
                  size: 'big',
                }}
              />
              <ClientList 
                clients={companyData.clientList.items} 
                companyPage
                useColor 
              />
              <Button ghost="true" to={companyData.presentButton.buttonLink}>
                {companyData.presentButton.buttonText}
              </Button>
            </div>
          </GeneralSection>
        </Container>
        <Container fullWidth>
          <MeetTheTeam data={companyData.theTeam.items}>
            <TextHeader
              mdTitle={companyData.meetTheTeam.title.title}
              subtitle={companyData.meetTheTeam.subtitleTop}
              text={companyData.meetTheTeam.text.text}
              theme={{
                size: 'big',
                align: 'center',
              }}
            />
          </MeetTheTeam>
        </Container>
        <Container>
          <MasonryCards images={companyData.images} />
        </Container>
        <Container fullWidth>
          <HistoryTimeline data={companyData.history.items} />
        </Container>
        <Container>
          <GeneralSection>
            <SingleQuote
              quote={companyData.quote.quote}
              author={companyData.quote.author}
            />
          </GeneralSection>
        </Container>
      </Layout>
    </>
  )
}
export const query = graphql`
  query CompanyPageQuery {
    contentfulCompanyPage {
      pageHeader {
        title {
          title
        }
        subtitleTop
      }
      frontImage {
        fluid {
          ...GatsbyContentfulFluid_withWebp_noBase64
        }
      }
      theBegining {
        ... on ContentfulTextHeader {
          id
          text {
            text
          }
          subtitleTop
          title {
            title
          }
        }
        ... on ContentfulButton {
          id
          name
          buttonText
          buttonLink
          external
          isAbsolutePath
        }
      }
      ourMission {
        header {
          subtitleTop
          themeSize
          themeAlign
          text {
            text
          }
          title {
            title
          }
        }
        items {
          id
          icon {
            fluid {
              ...GatsbyContentfulFluid_withWebp_noBase64
            }
            file {
              url
            }
          }
          title
          subtitle {
            subtitle
          }
        }
      }
      #             ourVision {
      #                subtitleTop
      #                text {
      #                  text
      #                }
      #                title {
      #                  title
      #                }
      #             }
      #             present {
      #                subtitleTop
      #                text {
      #                  text
      #                }
      #                title {
      #                  title
      #                }
      #             }
      clientList {
        items {
          id
          iconColor {
            file {
              url
            }
          }
        }
      }
      presentButton {
        buttonLink
        buttonText
      }
      meetTheTeam {
        subtitleTop
        text {
          text
        }
        title {
          title
        }
      }
      theTeam {
        items {
          id
          name
          picture {
            fluid {
              ...GatsbyContentfulFluid_withWebp_noBase64
            }
          }
          role
          linkedIn
        }
      }
      images {
        cardButton {
          buttonLink
          buttonText
        }
        cardTitle
        image1 {
          fluid {
            ...GatsbyContentfulFluid_withWebp_noBase64
          }
        }
        image2 {
          fluid {
            ...GatsbyContentfulFluid_withWebp_noBase64
          }
        }
        image3 {
          fluid {
            ...GatsbyContentfulFluid_withWebp_noBase64
          }
        }
      }
      history {
        items {
          id
          subtitle
          text {
            text
          }
          title
        }
      }
      quote {
        author {
          image {
            fluid {
              ...GatsbyContentfulFluid_withWebp_noBase64
            }
          }
          linkedInLink
          name
          position
        }
        quote {
          text {
            text
          }
          companyLogo {
            file {
              url
            }
          }
          caseStudyLink
        }
      }
    }

    allContentfulTimedSlider(filter: { page: { eq: "Company" } }) {
      edges {
        node {
          items {
            id
            title
            subtitle {
              subtitle
            }
            icon {
              file {
                url
              }
              fluid {
                ...GatsbyContentfulFluid_withWebp_noBase64
              }
            }
          }
          header {
            title {
              title
            }
            subtitleTop
            text {
              text
            }
            themeSize
            themeAlign
          }
        }
      }
    }
  }
`
export default CompanyPage
